import {
  FLOATING_TOOL_PIPES_MOVED,
  CONTEXT_DESELECTED_PIPE_ELEMENT,
  PIPE_SET_ACCESORY,
  PIPE_REMOVE_ACCESORY, PIPE_RESET_ACCESSORIES
} from "../lib/types";

export const floatingToolPipesMoved = ( x, y ) => dispatch => {
  dispatch({
    type: FLOATING_TOOL_PIPES_MOVED,
    payload: { x, y }
  });
};

export const floatingToolPipesClose = () => dispatch => {
  dispatch({
    type: CONTEXT_DESELECTED_PIPE_ELEMENT
  });
};

export const resetPipeAccessories = () => dispatch => {
  dispatch({
    type: PIPE_RESET_ACCESSORIES
  });
};

export const setPipeAccessory = ( id, position, placement, type, size ) => dispatch => {
  dispatch({
    type: PIPE_SET_ACCESORY,
    payload: {
      id,
      position,
      placement,
      type,
      size
    }
  });
};

export const removePipeAccessory = ( id, position, placement ) => dispatch => {
  dispatch({
    type: PIPE_REMOVE_ACCESORY,
    payload: {
      id,
      position,
      placement
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/floating-tool-pipes-actions.js